import { render, staticRenderFns } from "./TestimonialsReviews.vue?vue&type=template&id=58cbd486&"
import script from "./TestimonialsReviews.vue?vue&type=script&lang=js&"
export * from "./TestimonialsReviews.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsReviews.vue?vue&type=style&index=0&id=58cbd486&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports